import React from 'react';
import site from 'pro/config/site';
import EmailLink from '@base/snippets/EmailLink';
import PhoneLink, { PhoneLinkProps } from '@base/snippets/PhoneLink';
import WhatsAppLink from '@base/snippets/WhatsAppLink';
import { useStoreState } from 'base/store';
import { merge } from 'ava-util/dist/data';

type ContactPhoneProps = Omit<PhoneLinkProps, 'value'>;

type IProps = {
    className?: string;
    renderText?: (value: string) => React.ReactNode;
    type?: string; //用途
}

type ISiteContact = {
    email?: Record<string, string>;
    phone?: {
        url: string;
        text: string;
    },
    address?: string;
    whatsApp?: string;
};

const useContact = (): ISiteContact => {
    return site.contact;
}

export const ContactEmail: React.FC<IProps> = props => {
    const { email } = useContact();
    const { type = 'default', ...rest } = props;
    const value = email?.[type] || email?.default;
    return value ? <EmailLink value={value} {...rest}/> : null
};

export const ContactPhone: React.FC<ContactPhoneProps> = props => {
    const { phone } = useContact();
    return phone ? <PhoneLink value={phone.url} {...props}>{phone.text}</PhoneLink> : null
};

export const ContactAddress: React.FC<IProps> = props => {
    const { address } = useContact();
    return address ? <span {...props}>{address}</span> : null
};

export const ContactWhatsApp: React.FC<IProps> = props => {
    const { whatsApp } = useContact();
    return whatsApp ? <WhatsAppLink value={whatsApp} {...props}/> : null
};